import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/* Component */
import CustomerIdentify from 'components/CustomerIdentify';

/* API */
import TenpoService from 'api/TenpoService';
import { TenpoResponseDto as TenpoType } from 'api/generated/openapi';

/* Layout */
import Layout from 'layout/Layout';
import LoadingSpinner from 'util/LoadingSpinner';

const CustomerIdentifyPage: React.FC = () => {
  const { tenpoCode } = useParams(); // URL パラメーターを取得
  const [tenpo, setTenpo] = useState<TenpoType | null>(null); // 初期値を null に変更
  const [isLoading, setIsLoading] = useState(true);
  const titleSuffix = 'ホームメイト';
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTenpo = async () => {
      try {
        console.log(`Fetching tenpo data for code: ${tenpoCode}`); // デバッグ用
        const result = await TenpoService.get({ tenpoCode: tenpoCode ?? '' });
        setTenpo(result);
      } catch (error) {
        console.error('Error fetching tenpo data:', error);
        navigate('/404'); // エラー時は 404 ページに遷移
      } finally {
        setIsLoading(false);
      }
    };

    fetchTenpo();
  }, [tenpoCode]);

  const pageTitle = `${titleSuffix} ${tenpo?.tenpoName || ''}`;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!tenpo?.tenpoName) {
    navigate('/404');
    return null; // 必要ないが、型安全のため追加
  }

  return (
    <Layout pageTitle={pageTitle}>
      <CustomerIdentify tenpoName={tenpo.tenpoName} tenpoCode={tenpoCode || ''} />
    </Layout>
  );
};

export default CustomerIdentifyPage;
